export const ERROR_MESSAGES = {
  CREATE_PROFILE_FAIL: `There was an error trying to create a recruitment profile
    with your selection, please try again.`,
  SAVE_PROFILE_FAIL: 'Unable to save your profile, please try again.',
  LOAD_STATIC_DATA_FAIL: `Unable to load information required to create your profile.
    Please try again.`
};

export const SCHEDULE_TYPES = [
  { value: 'any', label: 'Any Day' },
  { value: 'weekdays', label: 'Any Weekday' },
  { value: 'weekends', label: 'Any Weekend' },
  { value: 'custom', label: 'Custom Schedule' }
];

export const enum RecruitmentConfigSteps {
  CharacterSlots = 'character-slots',
  Schedule = 'schedule',
  Requirements = 'requirements',
  Publish = 'publish',
  PlayerSlots = 'player-slots'
}
